import { FC } from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import styled from 'styled-components'
import Health from 'pages/Health'
import Header from 'ui/molecules/Header'
import Footer from 'ui/molecules/Footer'
import config from 'const/config'
import InfoRequestPage from 'pages/InfoRequestPage'
import ResultPage from 'pages/ResultPage'
import GlobalStyles from './globalStyles'
import { isNotIE } from './helpers'

const Main = styled.main`
  flex: 1;
`

const Container = styled(props =>
  // eslint-disable-next-line react/jsx-props-no-spreading
  isNotIE ? <Main {...props} /> : <div {...props} />
)``

/**
 * Workaround to get base name properly, it will be called only first load
 * @returns basename
 */
const getPathUrl = (): string => {
  if (window.location.pathname === '/') return '/'
  const path = window.location.pathname
    .split('/')
    .filter(item => item !== '')
    .shift()
    ?.toLowerCase()
  if (`/${path}` === config.BASENAME) return config.BASENAME
  return '/'
}

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <InfoRequestPage />
    },
    {
      path: '/complete',
      element: <ResultPage />
    },
    {
      path: '/manage/info',
      element: <Health />
    }
  ],
  {
    basename: getPathUrl()
  }
)

const App: FC<unknown> = () => {
  return (
    <>
      <GlobalStyles />
      <Header />
      <Container>
        <RouterProvider router={router} />
      </Container>
      <Footer />
    </>
  )
}

export default App
